import axios from "axios";

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Trading API service functions
 * Handles all trading and fund movement related API calls
 */

// Gets linked credit card details for an account
export const getLinkedCreditCard = async (accountId) => {
    try {
        const response = await axios.post(
            `${API_URL}/api/trading/get-linked-credit-card`,
            {
                accountId,
            },
            {
                withCredentials: true,
            },
        );

        return response.data;
    } catch(error) {
        return {
            error:
                error.response?.data?.error ||
                "Failed to get linked credit card",
        };
    }
};
